import React from 'react'

import { SORT_BY } from 'Pods/SearchPage/Store/constants'

const sortingFilters = [
  {
    value: SORT_BY.BEST_MATCH,
    label: 'Best Match',
    count: <span>Default</span>,
  },
  {
    value: SORT_BY.TOP_SELLING,
    label: 'Top Sellers',
  },
  {
    value: SORT_BY.NEWEST,
    label: 'Newest',
  },
  {
    value: SORT_BY.OLDEST,
    label: 'Oldest',
  },
  {
    value: SORT_BY.LOWEST_PRICE,
    label: 'Lower Price',
  },
  {
    value: SORT_BY.HIGHEST_PRICE,
    label: 'Higher Price',
  },
  {
    value: SORT_BY.TRENDING,
    label: 'Trending',
  },
]

export const sortingFiltersConfig = [{
  label: null,
  filters: sortingFilters.map(filter => ({
    value: filter.value,
    label: filter.label,
    count: filter.count,
  })),
}]
